import HasID from "./HasID";
import TrackedObject from "./TrackedObject";
import { PriceSchedule } from "./PriceSchedule";

export interface PriceScheduleMemberTier extends HasID, TrackedObject {
    id: number;
    priceScheduleId: number;
    stripeProductId: string;
    memberPriceScheduleId: number;
    tierName: string;
    priority: number;
    isActive: boolean;
    
    // Navigation properties
    priceSchedule?: PriceSchedule;
    memberPriceSchedule?: PriceSchedule;
}

export class PriceScheduleMemberTier implements PriceScheduleMemberTier {
    id: number = 0;
    priceScheduleId: number = 0;
    stripeProductId: string = '';
    memberPriceScheduleId: number = 0;
    tierName: string = '';
    priority: number = 0;
    isActive: boolean = true;
    createdBy: string = '';
    createdDate: Date = new Date();
    updatedBy?: string;
    updatedDate?: Date;
    
    // Navigation properties
    priceSchedule?: PriceSchedule;
    memberPriceSchedule?: PriceSchedule;

    constructor(obj?: Partial<PriceScheduleMemberTier>) {
        if (obj) {
            Object.assign(this, obj);
        }
    }

    toString(): string {
        return `${this.tierName} (${this.stripeProductId})`;
    }
}